import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import * as Func from "../../../../../../../../helpers/functions";
import i18n from "../../../../../../../../constants/initLng";
import DEFINE, {
  DETAIL_ACTIONS,
  FEATURE_FLAGS,
  PATHS,
  TOUR_TABS,
  OBJECT_TYPE,
  OBJECT_TYPE_FOR_VINWONDER7,
  RATECODE,
  OBJECT_RATE_CODE_TYPE,
  UPLOAD_DIRECTORY,
} from "../../../../../../../../constants/Define";
import * as HMS from "../../../../../../common/component/Index";
import {
  message,
  Icon,
  Tooltip,
  Checkbox,
  Switch,
  Descriptions,
  Tabs,
  Divider,
} from "antd";
import AntSelect, {
  AntOption,
} from "../../../../../../common/component/AntSelect";
import Input from "../../../../../../common/component/Input";
import Wrapper from "./../../../../../../common/component/Wrapper";
import Button from "./../../../../../../common/component/Button";
import TextArea from "../../../../../../common/component/TextArea";
import {
  cloneDeep,
  merge,
  every,
  toArray,
  get,
  find,
  isEqual,
  filter,
  isEmpty,
  clone,
  sum,
  sumBy,
  uniqBy,
} from "lodash";
import TranslateButton from "../../../../../../common/component/TranslateButton";
import Tour, { TourTicket } from "../../../../../../../../models/Tour";
import Radio from "../../../../../../common/component/Radio";
import ObjectType from "../../../../../../../../models/ObjectType";
import classNames from "classnames";
import {v1 as uuidv1} from "uuid";

import { object } from "prop-types";
import SelectAmenity from "./SelectAmenity";
import { selectCopyLanguage } from "./copyLanguage";
import ComboRateCode from "./ComboRateCode";
import RichTextEditor, {
  ClassicEditor,
} from "containers/backend/common/component/RichTextEditor";
import { FormWrapperInputComponent } from "../../../../../../common/component/Index";
import AutoTranslate from "containers/backend/common/component/AutoTranslate/AutoTranslate";

const ListCols = [
  "id",
  "isDefault",
  "showDefault",
  "objectType",
  "rateCode",
  "originalPrice",
  "salePriceName",
  "surchargeCategories",
  "multiple",
  "minQuantity",
  "maxQuantity",
  "isEnableListing",
];

const ModelObjectFields = Object.getOwnPropertyNames(new ObjectType());
let permissionActions = [];
const { TabPane } = Tabs;

class TourTicketDetail extends Component {
  state = {
    action: DETAIL_ACTIONS.CREATE,
    tourTicket: new TourTicket(),
    validation: {},
    listProperties: [],
    objectTypeSelect: OBJECT_TYPE.SELECT.SAME_PRICE.id,
    objectTypeTable: {
      titleTable: Func.getTitleTable(ListCols, ["action"], ["id", "isDefault"]),
      modelObjectType: ModelObjectFields,
      componentTable: {
        showDefault: {
          width: 150,
          render: (text, record) => {
            return (
              <Checkbox
                checked={record.isDefault}
                onChange={(e) =>
                  this.onInputChangeObjectType(
                    record.objectTypeId,
                    record.rateCodeId,
                    e.target.checked,
                    "isDefault",
                    true
                  )
                }
              />
            );
            // return <Radio
            //             checked={record.isDefault}
            //             onChange={(e) => this.onInputChangeObjectType(record.objectTypeId, e.target.checked, 'isDefault', true) }>
            //         </Radio>
          },
        },
        objectType: {
          render: (text, record) => record.name,
        },
        rateCode: {
          render: (text, record) => {
            if (record.isCombo && record.objectTypeCombo?.length) {
              return record.objectTypeCombo.map((x) => (
                <div>{`${x.rateCodeCode} (${x.objectTypeCode})`}</div>
              ));
            }
            return text;
          },
        },
        originalPrice: {
          render: (text, record) => {
            if (record.isCombo && record.objectTypeCombo?.length) {
              return record.objectTypeCombo.map((x) => (
                <div>{Func.formatMoney(x.originalPrice)}</div>
              ));
            }
            return Func.formatMoney(record.originalPrice);
          },
        },
        salePriceName: {
          render: (text, record) => {
            if (record.isCombo && record.objectTypeCombo?.length) {
              return record.objectTypeCombo.map((x) => (
                <div>{Func.formatMoney(x.salePrice)}</div>
              ));
            }
            return Func.formatMoney(record.salePrice);
          },
        },
        surchargeCategories: {
          key: "surchargeCategoryIds",
          render: (values, record) => {
            return (
              values &&
              values.map((item) => <p className="m-b-0">{item.name}</p>)
            );
          },
        },
        multiple: {
          render: (text, record) => (
            <Input
              placeholder={this.props.t(`item.tourTicket.multiple`)}
              type={`text`}
              className={`form-control`}
              disabled={
                record.id ||
                this.state.action === DETAIL_ACTIONS.TRANSLATE ||
                record.isCombo
              }
              name={`multiple`}
              onChange={(e) =>
                e.target.value.length < 4 &&
                this.onInputChangeObjectType(
                  record.objectTypeId,
                  record.rateCodeId,
                  Number(e.target.value),
                  "multiple"
                )
              }
              value={Func.checkUndefine(record.multiple)}
              autoComplete="off"
            />
          ),
        },
        minQuantity: {
          render: (text, record) => (
            <Input
              placeholder={this.props.t(`item.tourTicket.minQuantity`)}
              type={`text`}
              className={`form-control`}
              disabled={
                record.id || this.state.action === DETAIL_ACTIONS.TRANSLATE
              }
              name={`multiple`}
              onChange={(e) =>
                e.target.value.length < 4 &&
                this.onInputChangeObjectType(
                  record.objectTypeId,
                  record.rateCodeId,
                  Number(e.target.value),
                  "minQuantity"
                )
              }
              value={Func.checkUndefine(record.minQuantity)}
              autoComplete="off"
            />
          ),
        },
        maxQuantity: {
          render: (text, record) => (
            <Input
              placeholder={this.props.t(`item.tourTicket.maxQuantity`)}
              type={`text`}
              className={`form-control`}
              disabled={
                record.id || this.state.action === DETAIL_ACTIONS.TRANSLATE
              }
              name={`multiple`}
              onChange={(e) =>
                e.target.value.length < 4 &&
                this.onInputChangeObjectType(
                  record.objectTypeId,
                  record.rateCodeId,
                  Number(e.target.value),
                  "maxQuantity"
                )
              }
              value={Func.checkUndefine(record.maxQuantity)}
              autoComplete="off"
            />
          ),
        },
        isEnableListing: {
          key: "isEnableListing",
          render: (isEnableListing, record, index) => (
            <Switch
              defaultChecked
              checked={isEnableListing}
              onChange={(checked) => this.onEnableListing(checked, index)}
            />
          ),
        },
        action: {
          align: "right",
          width: 100,
          render: (text, record, index) => {
            return (
              <>
                {(record.allowDelete === undefined || record.allowDelete) && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* {
                                this.props.tourState?.detail?.tour?.type === RATECODE.GROUP_TYPE.TOUR.value &&
                                <Tooltip title={ this.props.t(`action.edit`) }>
                                    <Button className="mr-1" onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        this.onProductSelected(record, index)
                                    }} disabled={ this.state.action === DETAIL_ACTIONS.TRANSLATE }>
                                        <Icon type={record.localId === this.state.tourTicketItemSelectedId ? "form" : "edit"}/>
                                    </Button>
                                </Tooltip>
                            } */}

                    <Tooltip title={this.props.t(`action.remove`)}>
                      <Button
                        onClick={() => this.onDeleteObjectType(record, index)}
                        disabled={
                          this.state.action === DETAIL_ACTIONS.TRANSLATE
                        }
                      >
                        <Icon type="delete" />
                      </Button>
                    </Tooltip>
                  </div>
                )}
              </>
            );
          },
        },
      },
    },
    deletedObjectsType: [],
    tourTicketProductItemsSamePrice: [],
    personPerTicketSamePrice: 0,
    tour: clone(this.props.tourState.detail.tour),
    selectedRateCodeId: null,
    comboRateCodes: [],
    rateCodeOptions: [],
    rateCodeBaseParams: {},
    rateCodeOptionPageIndex: 1,
    rateCodeOptionPageSize: 20,
    rateCodeOptionTotalCount: 0,
    rateCodeOptionFetching: false,
    rateCodeSearchTerm: "",
    isUseRateCodePaging: true,
    validateTabContent: [],
    activeKey: "0",
  };

  getAction(isTourType) {
    return {
      action: {
        align: "right",
        width: 100,
        render: (text, record, index) => {
          return (
            <>
              {(record.allowDelete === undefined || record.allowDelete) && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {isTourType && (
                    <Tooltip title={this.props.t(`action.edit`)}>
                      <Button
                        className="mr-1"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.onProductSelected(record, index);
                        }}
                        disabled={
                          this.state.action === DETAIL_ACTIONS.TRANSLATE
                        }
                      >
                        <Icon
                          type={
                            record.localId ===
                            this.state.tourTicketItemSelectedId
                              ? "form"
                              : "edit"
                          }
                        />
                      </Button>
                    </Tooltip>
                  )}

                  <Tooltip title={this.props.t(`action.remove`)}>
                    <Button
                      onClick={() => this.onDeleteObjectType(record, index)}
                      disabled={this.state.action === DETAIL_ACTIONS.TRANSLATE}
                    >
                      <Icon type="delete" />
                    </Button>
                  </Tooltip>
                </div>
              )}
            </>
          );
        },
      },
    };
  }

  getCopySourceId = (props = this.props) => {
    return new URLSearchParams(props.location?.search || "").get("copyFromId") || props.location?.state?.copyFromId;
  };

  isCopyMode = (props = this.props) => {
    return !props.match?.params?.id && !!this.getCopySourceId(props);
  };

  cleanTourTicketProductItemsForCopy = (items = []) => {
    return (items || []).map((item) => {
      const { id, tourTicketItemId, localId, ...rest } = item;
      return { ...rest, localId: uuidv1() };
    });
  };

  cleanTourTicketItemsForCopy = (items = []) => {
    return (items || []).map((item) => {
      const { id, localId, tourTicketId, ...rest } = item;
      return {
        ...rest,
        id: undefined,
        tourTicketId: undefined,
        localId: uuidv1(),
        tourTicketProductItems: this.cleanTourTicketProductItemsForCopy(
          item.tourTicketProductItems
        ),
      };
    });
  };

  prepareTourTicketForCopy = (tourTicket, props = this.props) => {
    const sourceTourTicket = cloneDeep(tourTicket);
    return {
      ...sourceTourTicket,
      id: undefined,
      code: undefined,
      tourId: props.match?.params?.tour_id || sourceTourTicket.tourId,
      name: `${sourceTourTicket.name || ""} Copy`,
      translations: [],
      translate: {},
      tourTicketItems: this.cleanTourTicketItemsForCopy(
        sourceTourTicket.tourTicketItems
      ),
    };
  };

  componentDidMount() {
    const { match, tourState } = this.props;
    permissionActions = Func.getPermissionActions(
      DEFINE.GENERAL.ROUTE_NAME.TOUR_TICKET
    );
    const tourTicketId = match?.params?.id;
    const copySourceId = this.getCopySourceId();
    if (tourTicketId) {
      this.setState({
        action: DETAIL_ACTIONS.UPDATE,
        tourTicket: new TourTicket(),
        deletedObjectsType: [],
      });
      this.props.onGetUpdate(tourTicketId);
    } else if (copySourceId) {
      this.setState({
        action: DETAIL_ACTIONS.CREATE,
        tourTicket: new TourTicket(),
        deletedObjectsType: [],
      });
      this.props.onGetUpdate(copySourceId);
    }
    const tourId = match?.params?.tour_id;
    const tourName = tourState?.detail?.tourName;
    if (tourId) {
      if (tourId !== tourState?.detail?.tour?.id || !tourName) {
        this.props.getTourDetail(tourId);
      }
      this.onChange(tourId, "tourId");
    }
    this.props.onListAllProperties();
    // this.props.getRateCodeListAll();
    // this.props.getAllObjectType();
    this.props.getAllSurchargeCategories();
  }

  componentWillUnmount() {
    if (this.rateCodeSearchTimer) {
      clearTimeout(this.rateCodeSearchTimer);
    }
  }

  componentDidUpdate(prevProps) {
    const prevTourType = prevProps.tourState?.detail?.tour?.type;
    const currentTourType = this.props.tourState?.detail?.tour?.type;
    if (prevTourType !== currentTourType) {
      this.setState({
        objectTypeTable: {
          ...this.state.objectTypeTable,
          action: this.getAction(
            currentTourType === RATECODE.GROUP_TYPE.TOUR.value
          ),
        },
      });
    }
  }

  getRateCodeParamsByTour = (tour = {}) => {
    if (tour.type === RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.value) {
      return {
        productType: tour.type,
        siteCode: tour.siteCode,
      };
    }
    const lengthOfTour = tour.lengthOfTour || "";
    const lengthOfTours = lengthOfTour.split(".");
    const lengOfStay = lengthOfTours.length > 1 ? lengthOfTours[1] : 0;
    const rateCodeParams = { productType: tour.type };
    if (Number(lengOfStay) >= 0) {
      rateCodeParams.lengOfStay = lengOfStay;
    }
    return rateCodeParams;
  };

  getMergedRateCodes = (props = this.props) => {
    const rateCodeDetailMap = props.rateCodeState?.rateCodeDetailMap || {};
    return uniqBy([
      ...(this.state.rateCodeOptions || []),
      ...toArray(rateCodeDetailMap),
      ...(props.rateCodeState?.rateCodeAll || []),
    ].filter(Boolean), "id");
  };

  getRateCodeById = (id, props = this.props) => {
    return find(this.getMergedRateCodes(props), (item) => item.id === id);
  };

  getSelectedRateCodeOptions = () => {
    const { tourTicket, selectedRateCodeId, comboRateCodes } = this.state;
    const selectedIds = [
      tourTicket?.rateCodeId,
      selectedRateCodeId,
      ...(tourTicket?.objectTypePrice || []).map((item) => item.rateCodeId),
      ...(comboRateCodes || []).map((item) => item.id),
    ].filter(Boolean);
    return selectedIds.map((id) => this.getRateCodeById(id)).filter(Boolean);
  };

  getRateCodeOptionsForSelect = () => {
    if (!this.state.isUseRateCodePaging) {
      const rateCodeAll = this.props.rateCodeState?.rateCodeAll || [];
      if (!this.state.rateCodeSearchTerm) return rateCodeAll;
      const searchText = Func.vietnameseStringToUnicode(this.state.rateCodeSearchTerm.toLowerCase());
      return rateCodeAll.filter((item) => {
        const optionText = Func.vietnameseStringToUnicode(`${item.code || ""} ${item.name || ""}`.toLowerCase());
        return optionText.indexOf(searchText) >= 0;
      });
    }
    if (this.state.rateCodeSearchTerm) {
      return this.state.rateCodeOptions || [];
    }
    return uniqBy([
      ...(this.state.rateCodeOptions || []),
      ...this.getSelectedRateCodeOptions(),
    ], "id");
  };

  loadFallbackRateCodes = (params = this.state.rateCodeBaseParams) => {
    this.setState({ isUseRateCodePaging: false });
    this.props.getRateCodeListAll(params);
  };

  loadRateCodeOptions = (params = {}, append = false) => {
    const nextParams = {
      ...this.state.rateCodeBaseParams,
      pageIndex: 1,
      pageSize: this.state.rateCodeOptionPageSize,
      ...params,
    };
    this.setState({ rateCodeOptionFetching: true });
    this.props.getRateCodeListWithPaging(nextParams, {
      callbacks: {
        onSuccess: (result) => {
          const nextOptions = append
            ? uniqBy([...(this.state.rateCodeOptions || []), ...(result.result || [])], "id")
            : result.result || [];
          this.setState({
            rateCodeOptions: nextOptions,
            rateCodeOptionPageIndex: result.pageIndex || nextParams.pageIndex,
            rateCodeOptionPageSize: result.pageSize || nextParams.pageSize,
            rateCodeOptionTotalCount: result.totalCount || 0,
            rateCodeOptionFetching: false,
            rateCodeSearchTerm: nextParams.searchTerm || "",
            isUseRateCodePaging: true,
          });
        },
        onError: () => {
          this.setState({ rateCodeOptionFetching: false });
          this.loadFallbackRateCodes(nextParams);
        },
      },
    });
  };

  ensureRateCodeDetail = (id, callback) => {
    if (!id) return;
    const rateCode = this.getRateCodeById(id);
    if (rateCode) {
      callback && callback(rateCode);
      return;
    }
    this.props.getRateCodeDetailCache(id, {
      callbacks: {
        onSuccess: callback,
        onError: () => this.loadFallbackRateCodes(),
      },
    });
  };

  ensureRateCodeDetailsForTourTicket = (tourTicket = {}) => {
    const rateCodeIds = uniqBy((tourTicket.tourTicketItems || [])
      .map((item) => ({ id: item.rateCodeId }))
      .filter((item) => item.id), "id");
    rateCodeIds.forEach((item) => this.ensureRateCodeDetail(item.id));
  };

  onSearchRateCode = (searchTerm) => {
    this.setState({ rateCodeSearchTerm: searchTerm });
    if (this.rateCodeSearchTimer) {
      clearTimeout(this.rateCodeSearchTimer);
    }
    this.rateCodeSearchTimer = setTimeout(() => {
      this.loadRateCodeOptions({ pageIndex: 1, searchTerm }, false);
    }, 400);
  };

  onRateCodeDropdownScroll = (e) => {
    const target = e.target;
    const isBottom = target.scrollTop + target.offsetHeight >= target.scrollHeight - 10;
    const {
      rateCodeOptionFetching,
      rateCodeOptionPageIndex,
      rateCodeOptionPageSize,
      rateCodeOptionTotalCount,
      rateCodeOptions,
    } = this.state;
    if (!isBottom || rateCodeOptionFetching || (rateCodeOptions || []).length >= rateCodeOptionTotalCount) return;
    this.loadRateCodeOptions({
      pageIndex: rateCodeOptionPageIndex + 1,
      pageSize: rateCodeOptionPageSize,
    }, true);
  };

  getRateCodeSelectProps = () => ({
    showSearch: true,
    filterOption: false,
    onSearch: this.onSearchRateCode,
    onPopupScroll: this.onRateCodeDropdownScroll,
  });

  validation = (field, reload) => {
    const { t, tourTicketUpdate } = this.props;
    const { objectTypeSelect } = this.state;
    let tourTicket = cloneDeep(this.state.tourTicket);
    // tourTicket.propertyId = tourTicket.propertyIds.length ? propertyIds : undefined
    tourTicket.objectTypeValidate =
      tourTicket.objectTypePrice && tourTicket.objectTypePrice.length;
    let result = {};
    if (!reload) {
      let validate = {
        required: {
          name: Func.formatValidation(
            t("validation.statusCode.code.1"),
            t(`item.tourTicket.ticketName`)
          ),
          // propertyIds: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tourTicket.propertyToUse`)),
          code: Func.formatValidation(
            t("validation.statusCode.code.1"),
            t(`item.tourTicket.code`)
          ),
        },
        maxLength: {
          code: Func.formatValidation(t("validation.statusCode.code.4"), 6),
        },
        minLength: {
          code: Func.formatValidation(
            t("validation.statusCode.code.MIN_CHAR"),
            6
          ),
          properties: Func.formatValidation(
            t("validation.statusCode.code.1"),
            t(`item.tourTicket.propertyToUse`)
          ),
        },
        maxValueNumber: {
          originalPrice: Func.formatValidation(
            t("validation.statusCode.code.8"),
            t(`item.tourTicket.salePercent`)
          ),
        },
        isCode: { code: t("validation.code") },
      };
      if (this.state.action === DETAIL_ACTIONS.CREATE) {
        validate.required.languageCode = Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`translate.defaultLanguage`)
        );
      }
      if (objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id) {
        validate.required.rateCodeId = Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.tourTicket.rateCode`)
        );
      }
      if (objectTypeSelect === OBJECT_TYPE.SELECT.SPECIFIC.id) {
        validate.required.objectTypeValidate = Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.tourTicket.objectTypeList`)
        );
      }
      let valueValidate = {
        maxValueNumber: {
          originalPrice: 100,
        },
        maxLength: { code: 6 },
        minLength: {
          code: 6,
          properties: 1,
        },
      };
      result = Func.multipleValidate(tourTicket, validate, valueValidate);
    } else {
      let validation = this.state.validation;
      result = Func.reloadValidation(validation, field);
    }
    this.setState({ validation: result });
    return result;
  };

  componentWillReceiveProps(nextProps) {
    const { match } = this.props;
    const id = match?.params?.id;
    const isCopyMode = this.isCopyMode(nextProps);
    const copySourceId = this.getCopySourceId(nextProps);
    const nextTourTicket =
      nextProps.tourState?.tourTicketDetail?.tourTicket;
    const currentTourTicket =
      this.props.tourState?.tourTicketDetail?.tourTicket;
    const shouldHydrateTourTicket =
      nextTourTicket &&
      (id || (isCopyMode && nextTourTicket.id === copySourceId)) &&
      (!isEqual(nextTourTicket, currentTourTicket) ||
        (id && nextTourTicket.id === id && this.state.tourTicket?.id !== id) ||
        (isCopyMode &&
          copySourceId &&
          nextTourTicket.id === copySourceId &&
          !this.state.tourTicket?.name));
    if (
      nextProps.tourState &&
      !isEqual(nextProps.tourState, this.props.tourState) &&
      nextProps.tourState.detail.tour.type
    ) {
      this.props.getAllObjectType({
        types: nextProps.tourState.detail.tour.type,
      });

      const rateCodeParams = this.getRateCodeParamsByTour(nextProps.tourState.detail.tour);
      this.setState({ rateCodeBaseParams: rateCodeParams }, () => {
        this.loadRateCodeOptions({ ...rateCodeParams, pageIndex: 1 }, false);
      });
    }
    if (shouldHydrateTourTicket) {
      let objectTypeSelect = OBJECT_TYPE.SELECT.SAME_PRICE.id;
      const sourceTourTicket = nextTourTicket;
      if (isCopyMode) {
        this.copySourceTranslations = cloneDeep(sourceTourTicket.translations || []);
        this.loadedCopySourceId = sourceTourTicket.id;
      }
      const tourTicket = isCopyMode
        ? this.prepareTourTicketForCopy(sourceTourTicket, nextProps)
        : sourceTourTicket;
      const rateCodeAll = this.getMergedRateCodes(nextProps);
      this.ensureRateCodeDetailsForTourTicket(tourTicket);
      let firstItemOfTourTicket = {};
      if (
        tourTicket &&
        tourTicket.tourTicketItems &&
        tourTicket.tourTicketItems.length > 0
      ) {
        firstItemOfTourTicket = tourTicket.tourTicketItems[0];
        if (firstItemOfTourTicket && firstItemOfTourTicket.objectType) {
          const objectType = firstItemOfTourTicket.objectType;
          objectTypeSelect =
            objectType.id === OBJECT_TYPE.SELECT.SAME_PRICE.id
              ? OBJECT_TYPE.SELECT.SAME_PRICE.id
              : OBJECT_TYPE.SELECT.SPECIFIC.id;
        }
      }
      const objectTypePrice =
        objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
          ? []
          : tourTicket.tourTicketItems
              .map((item) => {
                const tourTicketItemId = isCopyMode ? undefined : item.id;
                let newItem = {
                  ...item,
                  localId: item.id || item.localId || uuidv1(),
                };
                const objectType = item.objectType;
                if (objectType && objectType.id) {
                  newItem = Object.assign(newItem, {
                    name: objectType.name,
                    objectTypeId: objectType.id,
                  });
                }
                const nextTourTicketProductItems =
                  this.getNextTourTicketProductItems(
                    rateCodeAll,
                    item.rateCodeId,
                    item.tourTicketProductItems,
                    tourTicketItemId
                  );
                newItem = Object.assign(newItem, {
                  tourTicketProductItems: nextTourTicketProductItems,
                  personPerTicket: item.personPerTicket,
                });
                return newItem;
              })
              .filter((item) => {
                return item.isDeleted === undefined || !item.isDeleted;
              });
      const tourTicketProductItemsSamePrice = [];
      tourTicket.tourTicketItems.forEach((el) =>
        el.tourTicketProductItems.forEach((e) => {
          tourTicketProductItemsSamePrice.push(
            isCopyMode
              ? this.cleanTourTicketProductItemsForCopy([e])[0]
              : e
          );
        })
      );
      const personPerTicketSamePrice =
        tourTicket?.tourTicketItems[0]?.personPerTicket;

      this.setState({
        objectTypeSelect: objectTypeSelect,
        tourTicket: Object.assign(new TourTicket(
          {
            ...tourTicket,
            rateCodeId:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? firstItemOfTourTicket.rateCodeId
                : undefined,
            originalPrice:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? firstItemOfTourTicket.percentDiscount
                : 0,
            salePrice:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? firstItemOfTourTicket.salePrice
                : undefined,
            objectTypePrice: objectTypePrice,
            multiple:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? firstItemOfTourTicket.multiple
                : undefined,
            minQuantity:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? firstItemOfTourTicket.minQuantity
                : undefined,
            maxQuantity:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? firstItemOfTourTicket.maxQuantity
                : undefined,
            surchargeCategoryIds:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? (firstItemOfTourTicket.surchargeCategories || []).map(
                    (item) => {
                      return item.id;
                    }
                  )
                : undefined,
            isEnableListing:
              objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id
                ? firstItemOfTourTicket.isEnableListing
                : undefined,
          },
          isCopyMode
        ), isCopyMode ? { languageCode: tourTicket.languageCode } : {}),
        action: isCopyMode
          ? DETAIL_ACTIONS.CREATE
          : tourTicket.id
            ? DETAIL_ACTIONS.UPDATE
            : this.state.action,
        deletedObjectsType: [],
        tourTicketProductItemsSamePrice,
        personPerTicketSamePrice,
      });
    }
    if (nextProps && nextProps.property) {
      this.setState({
        listProperties: nextProps.property.allProperties,
      });
    }
  }

  onChangeAmenity = (amenities) => {
    this.onChange(amenities, "amentity", "amentity");
  };

  onChange = (e, tag, validateTag) => {
    if (tag === "languageCode" && this.isCopyMode()) {
      const tourTicket = selectCopyLanguage(this.state.tourTicket, this.copySourceTranslations, e);
      this.setState({ tourTicket }, () => this.validation());
      return;
    }
    const tourTicket = cloneDeep(this.state.tourTicket);
    if (tag) {
      tourTicket[tag] = e;
      if (tag === "rateCodeId") {
        const objectRateCode = this.getRateCodeById(e);
        if (objectRateCode) {
          tourTicket["salePrice"] = objectRateCode.sellCost || 0;
          tourTicket["rateCode"] = objectRateCode.code || "";
        } else {
          this.ensureRateCodeDetail(e, (rateCode) => {
            const currentTourTicket = cloneDeep(this.state.tourTicket);
            if (currentTourTicket.rateCodeId !== e) return;
            currentTourTicket["salePrice"] = rateCode.sellCost || 0;
            currentTourTicket["rateCode"] = rateCode.code || "";
            this.setState({ tourTicket: currentTourTicket });
          });
        }
      }
      if (tag === "surchargeCategoryIds") {
        const { tourSurchargeCategories } = this.props.tourState;
        if (e && e.length > 0) {
          tourTicket["surchargeCategories"] = tourSurchargeCategories.filter(
            (item) => e.includes(item.id)
          );
        }
      }
      this.setState({ tourTicket });
      this.validation(validateTag || tag, true);
    } else {
      let params = Func.getValueForm(e);
      tourTicket[params.name] =
        typeof params.value === "string"
          ? params.value.trimLeft()
          : params.value;
      this.setState({ tourTicket });
      this.validation(params.name, true);
    }
  };

  onChangeField = (field, value) => {
      const tourTicket = this.state.tourTicket;
      tourTicket[field] = value;
      this.setState({ tourTicket });
  }

  onChangeContent = (field, value, index) => {
    const tourTicketClone = cloneDeep(this.state.tourTicket);
    tourTicketClone.extraInfos[index][field] = value.trimLeft();
    this.setState({ tourTicket: tourTicketClone });
    // this.props.onChange("extraInfos", extraInfos);
  };

  onChangeTabDetail = (activeKey) => {
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  add = () => {
    const tourTicketClone = cloneDeep(this.state.tourTicket);
    tourTicketClone.extraInfos.push({
      title: "Nội dung mới",
      content: "",
    });
    this.setState({ tourTicket: tourTicketClone });
    // this.props.onChange("extraInfos", extraInfos);
  };

  remove = (targetKey) => {
    const tourTicketClone = cloneDeep(this.state.tourTicket);
    const indexDelele = parseInt(targetKey);

    if (tourTicketClone.extraInfos.length <= 1) {
      return message.error("Phải giữ ít nhất một bài viết !");
    }

    if (!!tourTicketClone.extraInfos[indexDelele].content) {
      return message.error("Không thể xoá bài viết đang có nội dung!");
    }

    tourTicketClone.extraInfos.splice(indexDelele, 1);
    this.setState({
      activeKey: (indexDelele > 0 ? indexDelele - 1 : indexDelele).toString(),
      tourTicket: tourTicketClone,
    });
  };

  onChangeProperty = (id) => {
    const listProperties = this.props.property.allProperties || [];
    const property = find(listProperties, (item) => item.id === id);
    return property && this.onChange(property, "property", "propertyId");
  };

  onChangeProperties = (ids) => {
    this.onChange(ids, "properties", "properties");
  };

  onChangeObjectType = (id) => {
    const allObjectType = this.props.objectTypeState.allObjectType || [];
    const objectType = find(allObjectType, (item) => item.id === id);
    this.resetRateCode(() => {
      this.onChange(
        { ...objectType, id: undefined, objectTypeId: objectType.id },
        "objectType"
      );
    });
  };

  resetRateCode = (callbackFunc) => {
    const tourTicket = cloneDeep(this.state.tourTicket);
    tourTicket.rateCodeId = undefined;
    tourTicket.salePrice = 0;
    tourTicket.rateCode = "";
    this.setState(
      {
        tourTicketItemSelectedId: undefined,
        tourTicket,
        selectedRateCodeId: null,
        ComboRateCode: [],
      },
      callbackFunc
    );
  };

  onAddObjectType = (isCombo = false) => {
    const tourTicket = cloneDeep(this.state.tourTicket);
    const rateCodeAll = this.getMergedRateCodes();
    const tourTicketProductItems = this.getNextTourTicketProductItems(
      rateCodeAll,
      tourTicket.rateCodeId,
      []
    );
    const objectType = Object.assign(tourTicket.objectType, {
      originalPrice: Math.round(
        tourTicket.salePrice / (1 - tourTicket.originalPrice * 0.01)
      ),
      rateCodeId: tourTicket.rateCodeId,
      rateCode: tourTicket.rateCode,
      salePrice: tourTicket.salePrice,
      multiple: tourTicket.multiple,
      isDefault: tourTicket.objectTypePrice < 1 ? true : false,
      percentDiscount: tourTicket.originalPrice,
      surchargeCategoryIds: tourTicket.surchargeCategoryIds,
      minQuantity: tourTicket.minQuantity,
      maxQuantity: tourTicket.maxQuantity,
      surchargeCategories: tourTicket.surchargeCategories,
      localId: uuidv1(),
      tourTicketProductItems,
      // for combo
      isCombo: isCombo,
      objectTypeCombo: isCombo
        ? this.state.comboRateCodes.map((x) => {
            return {
              rateCodeId: x.id,
              rateCodeCode: x.code,
              rateCodeName: x.name,
              originalPrice: Math.round(
                x.sellCost / (1 - tourTicket.originalPrice * 0.01)
              ),
              salePrice: x.sellCost,
              objectTypeId: x.objectTypeId,
              objectTypeCode: x.objectTypeCode,
              objectTypeName: x.objectTypeName,
            };
          })
        : [],
    });

    tourTicket.objectTypePrice = tourTicket.objectTypePrice.concat([
      objectType,
    ]);
    tourTicket.originalPrice = 0;
    tourTicket.salePrice = undefined;
    tourTicket.objectType = undefined;
    tourTicket.rateCodeId = undefined;
    tourTicket.rateCode = undefined;
    tourTicket.surchargeCategoryIds = undefined;
    tourTicket.minQuantity = 1;
    tourTicket.maxQuantity = undefined;
    tourTicket.surchargeCategories = undefined;

    this.validation("objectTypeValidate", true);
    this.setState({ tourTicket, comboRateCodes: [] });
  };

  onDeleteObjectType = (objectType, index = 0) => {
    const tourTicket = cloneDeep(this.state.tourTicket);
    const { deletedObjectsType } = this.state;
    const oldDeletedObjectsType = deletedObjectsType;
    tourTicket.objectTypePrice = tourTicket.objectTypePrice.filter(
      (item) =>
        !(
          item.objectTypeId === objectType?.objectTypeId &&
          item.rateCodeId === objectType?.rateCodeId &&
          item.id === objectType.id
        )
    );

    if (objectType && objectType.id) {
      const existedData = oldDeletedObjectsType.filter((item) => {
        return item.id === objectType.id;
      });
      // if(objectType.isDefault && tourTicket.objectTypePrice.length > 0) {
      //     tourTicket.objectTypePrice[0].isDefault = true
      // }
      if (existedData && existedData.length <= 0) {
        oldDeletedObjectsType.push({
          ...objectType,
          isDeleted: true,
          isDefault: false,
        });
      }
    }
    this.setState({ tourTicket, deletedObjectsType: oldDeletedObjectsType });
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (this.props.tourState?.tourTicketDetail?.isFetching) return;
    if (this.isCopyMode() && this.loadedCopySourceId !== this.getCopySourceId()) {
      message.warning("Vui lòng chờ tải xong thông tin vé gốc.");
      return;
    }
    let {
      action,
      tourTicket,
      deletedObjectsType,
      tourTicketProductItemsSamePrice,
    } = this.state;
    let { onCreateTourTicket, onUpdateTourTicket, tourState } = this.props;
    const { tourTicketDetail } = tourState;
    let result = this.validation();
    const resultCheckContentTab = this.validateTabContent();
    // if(Number(tourTicket.salePrice) >= 100 || Number(tourTicket.salePrice) < 0){
    //     return message.error(i18n.t('validation.limitPercentPrice'))
    // }
    if (Object.keys(result).length < 1 && resultCheckContentTab) {
      if (this.validatePrice()) {
        return message.error(i18n.t("validation.limitSalePrice"));
      }
      if (this.validateMinMaxQuantity(tourTicket)) {
        return message.error(i18n.t("validation.minMaxInvalid"));
      }
      if (this.validateMinQuantity(tourTicket)) {
        return message.error(i18n.t("validation.minTicketInvalid"));
      }
      if (this.validateMaxQuantity(tourTicket)) {
        return message.error(i18n.t("validation.maxTicketInvalid"));
      }
      const deletedItem = deletedObjectsType.map(
        (item) => new ObjectType(item)
      );
      // const newItem = tourTicketProductItemsSamePrice.map(item => new ObjectType(item))
      let newData =
        deletedObjectsType && deletedObjectsType.length > 0
          ? {
              ...tourTicket,
              objectTypePrice: [...tourTicket.objectTypePrice, ...deletedItem],
            }
          : tourTicket;
      if (
        action === DETAIL_ACTIONS.CREATE ||
        action === DETAIL_ACTIONS.TRANSLATE
      ) {
        // if(this.validatePrice()) {
        //     return message.error(i18n.t('validation.limitSalePrice'))
        // }
        this.saveTourTicket(newData, onCreateTourTicket);
      } else if (
        this.state.action === DETAIL_ACTIONS.UPDATE ||
        action === DETAIL_ACTIONS.TRANSLATE
      ) {
        if (typeof newData.thumbImage !== "string") {
          newData.thumbImage = undefined;
        }
        // if(this.validatePrice()) {
        //     return message.error(i18n.t('validation.limitSalePrice'))
        // }
        this.saveTourTicket(
          merge(newData, { id: this.state.tourTicket.id }),
          onUpdateTourTicket
        );
      }
      if (tourTicketDetail && tourTicketDetail.isSuccessfulUpdated) {
        this.setState({ deletedObjectsType: [] });
      }
    } else {
      message.error(i18n.t("validation.checkForm"));
    }
  };

  saveTourTicket = (tourTicket, updateFunc) => {
    if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
      // this.onSaveTranslate(tourTicket)
      this.onSaveTranslate(tourTicket);
    } else {
      // if (this.state.objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id) {
      //     const samePriceObjectType = tourTicket.tourTicketItems && tourTicket.tourTicketItems.length > 0 ? tourTicket.tourTicketItems[0] : {};
      //     const objectType = new ObjectType({
      //         id: samePriceObjectType.id ? samePriceObjectType.id : "",
      //         objectTypeId: OBJECT_TYPE.SELECT.SAME_PRICE.id,
      //         originalPrice: tourTicket.originalPrice || tourTicket.salePrice,
      //         salePrice: tourTicket.salePrice,
      //     })
      //     tourTicket.objectTypePrice = [objectType];
      // } else {
      //     tourTicket.objectTypePrice = tourTicket.objectTypePrice.map(item => new ObjectType(item))
      // }
      // tourTicket.originalPrice = undefined;
      // tourTicket.salePrice = undefined;
      // tourTicket.objectType = undefined;
      // updateFunc(tourTicket)

      const dataTourTicket = this.parseDataPriceObjectType(tourTicket);

      dataTourTicket.originalPrice = 0;
      dataTourTicket.salePrice = undefined;
      dataTourTicket.objectType = undefined;
      dataTourTicket.rateCodeId = undefined;
      dataTourTicket.rateCode = undefined;
      dataTourTicket.minQuantity = 1;
      dataTourTicket.maxQuantity = undefined;
      dataTourTicket.isEnableListing = undefined;
      updateFunc(dataTourTicket, this.isCopyMode() ? {
        translations: cloneDeep(this.copySourceTranslations || []),
      } : undefined);
    }
  };

  parseDataPriceObjectType = (tourTicket) => {
    if (this.state.objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id) {
      const samePriceObjectType =
        tourTicket.tourTicketItems && tourTicket.tourTicketItems.length > 0
          ? tourTicket.tourTicketItems[0]
          : {};
      const objectType = new ObjectType({
        id: samePriceObjectType.id ? samePriceObjectType.id : "",
        objectTypeId: OBJECT_TYPE.SELECT.SAME_PRICE.id,
        rateCodeId: tourTicket.rateCodeId,
        rateCode: tourTicket.rateCode,
        salePrice: tourTicket.salePrice || 0,
        percentDiscount: tourTicket.originalPrice,
        originalPrice: Math.round(
          tourTicket.salePrice / (1 - tourTicket.originalPrice * 0.01)
        ),
        multiple: tourTicket.multiple,
        surchargeCategoryIds: tourTicket.surchargeCategoryIds,
        minQuantity: tourTicket.minQuantity,
        maxQuantity: tourTicket.maxQuantity,
        isEnableListing: tourTicket.isEnableListing,
        personPerTicket:
          this.state.personPerTicketSamePrice || tourTicket.personPerTicket,
        isDefault: true,
        tourTicketProductItems: this.state.tourTicketProductItemsSamePrice,
      });
      tourTicket.objectTypePrice = [objectType];
    } else {
      tourTicket.objectTypePrice = tourTicket.objectTypePrice.map(
        (item) => new ObjectType(item)
      );
    }
    return tourTicket;
  };

  onShowTranslate = (language) => {
    const { tourTicket } = this.state;
    tourTicket.setTranslate(language.code);
    tourTicket.setData();
    this.setState({ tourTicket, action: DETAIL_ACTIONS.TRANSLATE });
  };

  onExitTranslate = () => {
    const tourTicket = cloneDeep(this.state.tourTicket);
    const action = DETAIL_ACTIONS[tourTicket.id ? "UPDATE" : "CREATE"];
    tourTicket.setTranslate(undefined, true);
    tourTicket.setData();
    this.setState({ tourTicket, action });
  };

  onClickBack = () => {
    const tourId = this.props.match?.params?.tour_id;
    if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
      this.onExitTranslate();
    } else {
      const path = Func.getPathWithParams(
        PATHS.TOUR.DETAIL.path,
        { id: tourId },
        TOUR_TABS.TOUR_TICKET.id
      );
      this.props.history.push(path);
    }
  };

  onSaveTranslate = (tourTicket) => {
    tourTicket = tourTicket || this.state.tourTicket;
    const translateFunction = tourTicket.translate.id
      ? this.props.updateTourTicketTranslate
      : this.props.createTourTicketTranslate;
    translateFunction(tourTicket, tourTicket.languageCode);
    this.onExitTranslate();
  };

  onRemoveTranslate = (language) => {
    const { tourTicket } = this.state;
    tourTicket.setTranslate(language.code);
    this.props.deleteTourTicketTranslate(tourTicket, { id: tourTicket.id });
  };

  onInputChangeObjectType = (
    objectTypeId,
    rateCodeId,
    value,
    name,
    isSelectDetault
  ) => {
    const { tourTicket } = this.state;
    const { objectTypePrice } = tourTicket;
    if (objectTypePrice && objectTypePrice.length > 0) {
      objectTypePrice.map((item) => {
        if (
          item.objectTypeId === objectTypeId &&
          item.rateCodeId === rateCodeId
        ) {
          const originalPrice = parseInt(item.originalPrice) || 0;
          const parseIntCurrentValue = parseInt(value) || 0;
          item[name] =
            name === "salePrice" && parseIntCurrentValue > originalPrice
              ? originalPrice
              : value;
        }
        // else {
        //     if(isSelectDetault) {
        //         item.isDefault = false
        //     }
        // }
      });
    }
    tourTicket.objectTypePrice = objectTypePrice;
    this.setState({ tourTicket });
  };

  onEnableListing = (checked, index) => {
    const { tourTicket } = this.state;
    const { objectTypePrice } = tourTicket;
    objectTypePrice[index].isEnableListing = checked;
    this.setState({ tourTicket });
  };

  getTourTicketItemSelected = (id) => {
    const { tourTicket } = this.state;
    const { objectTypePrice = [] } = tourTicket || {};
    const tourTicketItemSelected = find(
      objectTypePrice,
      (item) => item.id === id || item.localId === id
    );
    return tourTicketItemSelected;
  };

  resetTourTicket = (tourTicket) => {
    tourTicket.originalPrice = 0;
    tourTicket.salePrice = undefined;
    tourTicket.objectType = undefined;
    tourTicket.rateCodeId = undefined;
    tourTicket.rateCode = undefined;
    tourTicket.surchargeCategoryIds = undefined;
    tourTicket.minQuantity = 1;
    tourTicket.maxQuantity = undefined;
    tourTicket.surchargeCategories = undefined;
  };

  getNextTourTicketProductItems = (
    rateCodeAll,
    rateCodeId,
    tourTicketProductItems = [],
    tourTicketItemId
  ) => {
    const objectRateCode = find(rateCodeAll, (item) => item.id === rateCodeId);
    let nextTourTicketProductItems = tourTicketProductItems.map((item) => {
      return { ...item, localId: item.id ? item.id : uuidv1() };
    });
    if (!objectRateCode) return nextTourTicketProductItems;
    objectRateCode.rateCodeProducts.forEach((product) => {
      const nextTourTicketProductItem = nextTourTicketProductItems.find(
        (f) => f.supplierProductId === product.id
      );
      if (!nextTourTicketProductItem) {
        let temp = {
          localId: uuidv1(),
          quantity: 1,
          supplierProductId: product.id,
        };
        if (tourTicketItemId) {
          temp = { ...temp, tourTicketItemId };
        }
        let existed = false;
        nextTourTicketProductItems = nextTourTicketProductItems.map((item) => {
          if (
            item.supplierProductId === temp.supplierProductId &&
            item.tourTicketItemId === temp.tourTicketItemId
          ) {
            existed = true;
            if (item.id) {
              return item;
            }
            return temp;
          }
          return item;
        });
        if (!existed) {
          nextTourTicketProductItems = [...nextTourTicketProductItems, temp];
        }
      }
    });
    return nextTourTicketProductItems;
  };

  onProductSelected = (record, index) => {
    if (
      !this.state.tourTicketItemSelectedId ||
      this.state.tourTicketItemSelectedId !== record.id
    ) {
      this.setState({ tourTicketItemSelectedId: record.localId });
    } else {
      this.setState({ tourTicketItemSelectedId: undefined });
    }
  };

  renderConfig = () => {
    const { t } = this.props;
    const { tourTicketItemSelectedId } = this.state;
    if (!tourTicketItemSelectedId) return;
    const tourTicketItemSelected = this.getTourTicketItemSelected(
      tourTicketItemSelectedId
    );
    if (!tourTicketItemSelected) return;
    const objectRateCode = this.getRateCodeById(tourTicketItemSelected.rateCodeId);
    if (!objectRateCode) return;
    const tourTicketProductItems =
      tourTicketItemSelected.tourTicketProductItems;
    const rateCodeProducts = objectRateCode.rateCodeProducts;
    return (
      <>
        <div className={`col-md-6`}>
          <div className="row">
            <div className={`col-md-12`}>
              <span style={{ lineHeight: "38px" }}>
                Tỷ lệ xuất kho với {tourTicketItemSelected?.multiple ?? 1}{" "}
                voucher
              </span>
            </div>
            {tourTicketProductItems &&
              tourTicketProductItems.map((item, index) => {
                const rateCodeProduct = rateCodeProducts.find(
                  (f) => f.id === item.supplierProductId
                );
                return (
                  <div className={`col-md-12`} key={index}>
                    <Descriptions className="white-bg w100-percent" column={2}>
                      <Descriptions.Item>
                        {`${rateCodeProduct && rateCodeProduct.name} :`}
                      </Descriptions.Item>
                      <Descriptions.Item>
                        <Input
                          // style={{ width: 50 }}
                          placeholder={t(`item.tourTicket.rateCodePrice`)}
                          type="number"
                          className={`form-control`}
                          onChange={(e) =>
                            this.handleTourProductItemQuantityChange(
                              tourTicketItemSelected.id,
                              item,
                              Number(e.target.value)
                            )
                          }
                          value={item.quantity}
                          autoComplete="off"
                        />
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                );
              })}
          </div>
        </div>
        <div className={`col-md-6`}>
          <div className={`col-md-12`}>
            <HMS.FormWrapperInputComponent
              className="row full-width col-md-12"
              classLabel="align-items-center d-flex mr-3"
              labelTitle={"Số lượng khách hàng trên mỗi voucher:"}
            >
              <Input
                style={{ width: 50 }}
                placeholder={t(`item.tourTicket.rateCodePrice`)}
                type={`number`}
                className={`form-control`}
                onChange={(e) =>
                  this.handlePersonPerTicketChange(Number(e.target.value))
                }
                value={this.getPersonPerTicket()}
                autoComplete="off"
              />
            </HMS.FormWrapperInputComponent>
          </div>
        </div>
      </>
    );
  };

  renderConfigSamePrice = () => {
    const { t } = this.props;

    const { tourTicket, tourTicketProductItemsSamePrice } = this.state;
    const tourTicketItemSelectedId = tourTicket?.rateCodeId;
    return (
      <>
        <div className="row">
          {/* <div className={ `col-md-6` }>
                {!isEmpty(tourTicketProductItemsSamePrice) && 
                    <span style={{ lineHeight: "38px" }}>Tỷ lệ xuất kho với {tourTicket.multiple ?? 1} voucher</span>
                }
                {tourTicketProductItemsSamePrice && tourTicketProductItemsSamePrice.map((item, index) => {
                    const { rateCodeAll } = this.props.rateCodeState;
                    const rateCodeProducts = (rateCodeAll?.map(x=>x.rateCodeProducts)?.flat() || [])
                    const supplierProduct = rateCodeProducts.find(x=> x.id === item.supplierProductId);
                    return (
                    <div key={index} className={ `col-md-12` }>
                        <HMS.FormWrapperInputComponent
                            className="row full-width col-md-12 p-0"
                            classLabel="m-0 align-items-center d-flex mr-3"
                            labelTitle={`${supplierProduct?.name} :`}
                        >
                        <Input
                            style={{ width: 50 }}
                            placeholder={ t(`item.tourTicket.quantity`) }
                            type="number"
                            className={ `form-control`}
                            onChange={e => this.onChangeQualitySamePrice(Number(e.target.value),item.supplierProductId)}
                            autoComplete="off"
                            value={item.quantity}
                        />
                        </HMS.FormWrapperInputComponent>
                    </div>
                )})}
                </div> */}
          {!isEmpty(tourTicketProductItemsSamePrice) && (
            <div className={`col-md-6`}>
              <div className={`col-md-12`}>
                <HMS.FormWrapperInputComponent
                  className="row full-width col-md-12"
                  classLabel="m-0 align-items-center d-flex mr-3"
                  labelTitle={"Số lượng khách hàng trên mỗi voucher"}
                >
                  <Input
                    style={{ width: 50 }}
                    placeholder={t(`item.tourTicket.rateCodePrice`)}
                    type={`number`}
                    className={`form-control`}
                    onChange={(e) =>
                      this.handlePersonPerTicketChangeSamePrice(
                        Number(e.target.value)
                      )
                    }
                    value={this.getPersonPerTicketSamePrice()}
                    autoComplete="off"
                  />
                </HMS.FormWrapperInputComponent>
              </div>
            </div>
          )}
        </div>
      </>
    );
  };

  handleTourProductItemQuantityChange = (tourTicketItemId, item, value) => {
    const { tourTicket } = this.state;
    tourTicket.objectTypePrice = tourTicket.objectTypePrice.map(
      (objectTypePriceItem) => {
        if (objectTypePriceItem.id === tourTicketItemId) {
          objectTypePriceItem.tourTicketProductItems =
            objectTypePriceItem.tourTicketProductItems.map(
              (tourTicketProductItem) => {
                const localId = item.localId;
                if (localId && tourTicketProductItem.localId === localId) {
                  return { ...tourTicketProductItem, quantity: value };
                }
                return tourTicketProductItem;
              }
            );
        }
        return objectTypePriceItem;
      }
    );
    this.setState({ tourTicket });
  };

  getPersonPerTicket = () => {
    const { tourTicketItemSelectedId } = this.state;
    const tourTicketItemSelected = this.getTourTicketItemSelected(
      tourTicketItemSelectedId
    );
    return tourTicketItemSelected?.personPerTicket ?? 0;
  };

  getPersonPerTicketSamePrice = () => {
    const { personPerTicketSamePrice } = this.state;
    return personPerTicketSamePrice;
  };

  handlePersonPerTicketChange = (value) => {
    const { tourTicketItemSelectedId, tourTicket } = this.state;
    if (!tourTicketItemSelectedId) return;
    tourTicket.objectTypePrice = tourTicket.objectTypePrice.map(
      (objectTypePriceItem) => {
        if (objectTypePriceItem.id === tourTicketItemSelectedId) {
          return { ...objectTypePriceItem, personPerTicket: value };
        }
        return objectTypePriceItem;
      }
    );
    this.setState({ tourTicket });
  };

  handlePersonPerTicketChangeSamePrice = (value) => {
    this.setState({ personPerTicketSamePrice: value });
  };

  onSelectRateCodeID = (id) => {
    this.onChange(id, "rateCodeId");
    if (!id) return;
    this.ensureRateCodeDetail(id, (objectRateCode) => {
      const rateCodeProducts = objectRateCode.rateCodeProducts || [];
      const tourTicketProductItemsSamePrice =
        rateCodeProducts &&
        rateCodeProducts.map((el) => ({
          supplierProductCode: el?.code,
          supplierProductId: el.id,
          quantity: 1,
        }));

      this.setState({ tourTicketProductItemsSamePrice });
    });
  };

  onChangeQualitySamePrice = (value, id) => {
    const { tourTicketProductItemsSamePrice } = this.state;
    const RendertourTicketProductItemsSamePrice =
      tourTicketProductItemsSamePrice.map((item) => {
        if (item.supplierProductId === id) {
          return { ...item, quantity: value };
        }
        return item;
      });
    this.setState({
      tourTicketProductItemsSamePrice: RendertourTicketProductItemsSamePrice,
    });
  };

  onAddRateCodesIntoCombo = () => {
    const objectRateCode = this.getRateCodeById(this.state.selectedRateCodeId);
    if (!objectRateCode) return;
    const comboRateCodes = cloneDeep(this.state.comboRateCodes);
    comboRateCodes.push(objectRateCode);
    this.setState({ comboRateCodes: comboRateCodes });

    // update to validate for isDisabledAddObjectType
    const tourTicket = cloneDeep(this.state.tourTicket);
    if (comboRateCodes?.length > 0) {
      tourTicket["salePrice"] = sumBy(
        comboRateCodes.map((x) => x.sellCost || 0)
      );
      tourTicket["rateCode"] = comboRateCodes[0].code || "";
      tourTicket["rateCodeId"] = comboRateCodes[0].id;
      this.setState({ tourTicket: tourTicket });
    }
  };

  getSelectedRateCode = (isCombo) => {
    const { tourTicket, selectedRateCodeId } = this.state;
    if (isCombo) {
      return selectedRateCodeId;
    }
    return (this.getMergedRateCodes() || []).some((el) => el?.id === tourTicket.rateCodeId)
      ? tourTicket.rateCodeId
      : undefined;
  };

  validateTabContent = () => {
    let result = [];
    let isErrors = 0;
    const { t } = this.props;
    const tourTicket = { ...this.state.tourTicket };
    let validate = {
      required: {
        title: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.tour.titleContent`)
        ),
        content: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.tour.content`)
        ),
      },
      maxLength: {
        title: Func.formatValidation(t("validation.statusCode.code.4"), 50),
      },
    };
    let valueValidate = {
      maxLength: { title: 50 },
    };
    tourTicket.extraInfos.forEach((info, index) => {
      const resultInfo = Func.multipleValidate(
        info,
        validate,
        valueValidate,
        true
      );
      if (Object.keys(resultInfo).length > 0) {
        isErrors++;
      }
      result.push(resultInfo);
    });
    const uniqTour = uniqBy(tourTicket.extraInfos, "title");
    if (tourTicket.extraInfos.length > uniqTour.length) {
      isErrors++;
      message.error("Tiêu đề bài viết không được trùng !");
      return false;
    }

    this.setState({ validateTabContent: result });
    return isErrors === 0;
  };

  render() {
    const { t, property, tourState, objectTypeState, rateCodeState, autoTranslateState } =
      this.props;

    const listProperties = property.allProperties || [];
    const { tourTicketDetail, tourSurchargeCategories, detail } = tourState;
    const { allObjectType } = objectTypeState;
    const { isTranslating } = autoTranslateState.tourTicket;

    const allObjectTypeForVinWonder = allObjectType.filter(
      (m) =>
        OBJECT_TYPE_FOR_VINWONDER7.includes(m.code) ||
        m.rateCodeType === OBJECT_RATE_CODE_TYPE.Multi.id
    );
    const allObjectTypeForVinWonderWithoutCombo = allObjectType.filter((m) =>
      OBJECT_TYPE_FOR_VINWONDER7.includes(m.code)
    );

    const {
      tourTicket,
      validation,
      action,
      objectTypeSelect,
      tourTicketItemSelectedId,
      personPerTicketSamePrice,
      comboRateCodes,
    } = this.state;
    const { titleTable, modelObjectType, componentTable } =
      this.state.objectTypeTable;

    //check is Combo
    const isCombo =
      tourTicket.objectType?.rateCodeType === OBJECT_RATE_CODE_TYPE.Multi.id;

    const isDisabledAddObjectType =
      tourTicket.salePrice === undefined ||
      !tourTicket.objectType?.objectTypeId ||
      !tourTicket.rateCodeId ||
      (tourTicket.originalPrice &&
        tourTicket.originalPrice >= tourTicket.salePrice) ||
      (isCombo &&
        (!comboRateCodes?.length ||
          comboRateCodes.some((x) => !x.objectTypeId)));

    const rateCodeAll = this.getRateCodeOptionsForSelect();
    let listPropertyInUse = listProperties;
    if (tourState?.detail?.tour?.properties.length > 0) {
      listPropertyInUse = listProperties.filter((item) =>
        tourState?.detail?.tour.properties.includes(item.id)
      );
    }

    //only show inventory fields for tour
    const isTourType = detail?.tour?.type === RATECODE.GROUP_TYPE.TOUR.value;

    return (
      <Fragment>
        <HMS.LoadingComponent spinning={tourTicketDetail.isFetching || isTranslating}>
          <HMS.PageListComponent className="form-detail-page">
            <HMS.HeaderListComponent
              path={this.props.match.path}
              groupPath={"tourTickets"}
              titleHeader={
                <Fragment>
                  {action === DETAIL_ACTIONS.CREATE
                    ? Func.capitalizeFirstLetter(
                        `${t("action.create")} ${t("item.tourTicket.title")}`
                      )
                    : Func.capitalizeFirstLetter(
                        `${t("action.update")} ${t("item.tourTicket.title")}`
                      )}
                  : {tourState?.detail?.tour?.tourName || ""}
                </Fragment>
              }
              componentRight={
                FEATURE_FLAGS.TRANSLATE_ENABLE && (
                  <TranslateButton
                    languages={tourTicket.translations}
                    current={tourTicket.languageCode}
                    validation={validation.languageCode}
                    onChange={this.onShowTranslate}
                    onClear={this.onExitTranslate}
                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                    onSelectDefault={(language) =>
                      this.onChange(language.code, "languageCode")
                    }
                    onRemove={this.onRemoveTranslate}
                  />
                )
              }
            />
            <HMS.FormActionComponent
              onSubmit={this.onSubmit}
              action={action}
              showActiveComponent={action !== DETAIL_ACTIONS.TRANSLATE}
              isSubmit={false}
              isGetItem={false}
              onClickBack={this.onClickBack}
              backButtonText={
                action === DETAIL_ACTIONS.TRANSLATE
                  ? t(`action.cancel`)
                  : t(`action.back`)
              }
              titleButtonSubmit={
                action === DETAIL_ACTIONS.TRANSLATE
                  ? t(`action.save`)
                  : undefined
              }
              activeComponent={"SWITCH"}
              onChangeActive={(e) => this.onChange(e.value, e.name)}
              titleActiveComponent={
                tourTicket.isAvailable
                  ? t(`item.tourTicket.isAvailable`)
                  : t(`item.tourTicket.isUnAvailable`)
              }
              statusActiveName={`isAvailable`}
              statusActive={tourTicket.isAvailable}
              submitButtonRight={true}
            >
              <HMS.FormWrapperItem>
                <div className={`col-md-6`}>
                  <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={tourTicket.name}
                    validation={validation.name}
                    labelTitle={t(`item.tourTicket.ticketName`)}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      name="name"
                      onChange={this.onChange}
                      value={tourTicket.name}
                    />
                  </HMS.FormWrapperInputComponent>
                </div>
                <div className={`col-md-6`}>
                  <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={tourTicket.code}
                    validation={validation.code}
                    labelTitle={t(`item.tourTicket.code`)}
                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={t(`item.tourTicket.codePlaceholder`)}
                      className="form-control"
                      name="code"
                      disabled={Number(tourTicket.soldQuantity) > 0}
                      onChange={this.onChange}
                      value={tourTicket.code}
                    />
                  </HMS.FormWrapperInputComponent>
                </div>
                <div className={`col-md-6`}>
                  <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={tourTicket.properties}
                    validation={validation.properties}
                    labelTitle={t(`item.tourTicket.propertyToUse`)}
                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                  >
                    {/* <AntSelect className="select-destination"
                                            showArrow showSearch
                                            placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tourTicket.propertyToUse")).toLowerCase()) }
                                            value={ tourState?.detail?.tour.properties.includes(tourTicket.property?.id) ? tourTicket.property?.id : tourTicket.property?.name }
                                            onChange={ this.onChangeProperty }
                                            style={ { width: '100%' } }
                                            filterOption={ this.selectFilterSearch }
                                        >
                                            { listPropertyInUse.map(d => (
                                                <AntOption key={ d.id } value={ d.id }>{ d.name }</AntOption>
                                            )) }
                                        </AntSelect> */}
                    <AntSelect
                      className="select-types"
                      showArrow
                      mode="multiple"
                      name="propertyIds"
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.select") +
                          " " +
                          t("item.tourTicket.propertyToUse")
                        ).toLowerCase()
                      )}
                      value={tourTicket.properties}
                      onChange={this.onChangeProperties}
                      filterOption={this.selectFilterSearch}
                      style={{ width: "100%" }}
                    >
                      {(listProperties || []).map((property) => (
                        <AntOption key={property.id} value={property.id}>
                          {property.name}
                        </AntOption>
                      ))}
                    </AntSelect>
                  </HMS.FormWrapperInputComponent>
                </div>
                <div className={`col-md-6`}>
                  <SelectAmenity
                    tourTicket={tourTicket}
                    validation={validation.amentity}
                    onChangeAmenity={this.onChangeAmenity}
                    selectFilterSearch={this.selectFilterSearch}
                  />
                </div>
                <div className={`col-md-12`}>
                  <HMS.FormWrapperInputComponent
                    isValidation={true}
                    dataValidation={tourTicket.description}
                    validation={validation.description}
                    labelTitle={t(`item.tourTicket.shortDescriptionTransform`)}
                    tooltip={t(`item.tourTicket.shortDescriptionTooltip`)}
                  >
                    <RichTextEditor
                      editor={ClassicEditor}
                      data={tourTicket.description || ""}
                      config={{ uploadDirectory: UPLOAD_DIRECTORY.IMAGES }}
                      onChange={(event, editor) => {
                        const value = editor.getData();
                        return this.onChange(value, "description");
                      }}
                    />
                  </HMS.FormWrapperInputComponent>
                </div>
                <div className={`col-md-12`}>
                  <Divider />
                  <Tooltip title={t(`item.tourTicket.extraInfoTooltip`)} placement="top">
                    <label className="title">
                      {t(`item.tourTicket.extraInfo`)}
                    </label>
                  </Tooltip>
                  <Tabs
                    // hideAdd
                    onChange={this.onChangeTabDetail}
                    activeKey={this.state.activeKey}
                    className="tab-extra-infos"
                    type="editable-card"
                    onEdit={this.onEdit}
                  >
                    {tourTicket.extraInfos &&
                      (tourTicket.extraInfos || []).map((info, index) => (
                        <TabPane
                          closable={!(index === 0)}
                          tab={
                            <span
                              className={`tab-content ${
                                this.state.validateTabContent[index] &&
                                (this.state.validateTabContent[index].title ||
                                  this.state.validateTabContent[index].content)
                                  ? "is-errors"
                                  : ""
                              }`}
                            >
                              {info.title}
                            </span>
                          }
                          key={index}
                        >
                          <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                              isRequired={"right"}
                              isValidation={true}
                              dataValidation={info.title}
                              validation={
                                this.state.validateTabContent[index]?.title
                              }
                              labelTitle={t(`item.tour.titleContent`)}
                            >
                              <Input
                                placeholder=""
                                type={`text`}
                                className={`form-control`}
                                name={`title`}
                                onChange={(e) =>
                                  this.onChangeContent(
                                    "title",
                                    e.target.value,
                                    index
                                  )
                                }
                                value={Func.checkUndefine(info.title)}
                              />
                            </FormWrapperInputComponent>
                          </Wrapper>
                          <Wrapper className="col-md-12">
                            <FormWrapperInputComponent
                              isRequired={"right"}
                              isValidation={true}
                              dataValidation={info.content}
                              validation={
                                this.state.validateTabContent[index]?.content
                              }
                              labelTitle={t(`item.tour.content`)}
                            >
                              <RichTextEditor
                                editor={ClassicEditor}
                                data={info.content || ""}
                                config={{
                                  uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB,
                                }}
                                onChange={(event, editor) => {
                                  const value = editor.getData();
                                  return this.onChangeContent(
                                    "content",
                                    value,
                                    index
                                  );
                                }}
                              />
                            </FormWrapperInputComponent>
                          </Wrapper>
                        </TabPane>
                      ))}
                  </Tabs>
                  <Divider />
                </div>
                <div className={`col-md-3`}>
                  <HMS.FormWrapperInputComponent
                    labelTitle={Func.capitalizeFirstLetter(
                      (
                        t("placeHolderForm.select") +
                        " " +
                        t("item.tourTicket.objectType")
                      ).toLowerCase()
                    )}
                  >
                    <Wrapper>
                      <Radio.Group
                        value={objectTypeSelect}
                        disabled={
                          action === DETAIL_ACTIONS.UPDATE ||
                          action === DETAIL_ACTIONS.TRANSLATE
                        }
                        onChange={(e) =>
                          this.setState({ objectTypeSelect: e.target.value })
                        }
                      >
                        {toArray(OBJECT_TYPE.SELECT).map((type) => (
                          <Radio key={type.id} value={type.id}>
                            {t(`item.tourTicket.${type.key}`)}
                          </Radio>
                        ))}
                      </Radio.Group>
                    </Wrapper>
                  </HMS.FormWrapperInputComponent>
                </div>
                {objectTypeSelect === OBJECT_TYPE.SELECT.SAME_PRICE.id && (
                  <Fragment>
                    <div className={`col-md-10`}>
                      <HMS.FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        dataValidation={tourTicket.rateCodeId}
                        validation={validation.rateCodeId}
                        labelTitle={t(`item.tourTicket.salePrice`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <Wrapper className="d-flex align-items-center">
                          {/* <Input placeholder={ t(`item.tourTicket.originalPrice`) } type={ `currency` }
                                                        className={ `form-control mr-1` }
                                                        name={ `originalPrice` } onChange={ (e) => this.onChange(Number(e.target.value), 'originalPrice') }
                                                        value={ tourTicket.originalPrice } autoComplete="off"/> */}
                          {this.state.action === DETAIL_ACTIONS.CREATE &&
                            this.state?.tour?.type ===
                              RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id && (
                              <div className={`col-md-5 p-0`}>
                                <AntSelect
                                  className="select-destination"
                                  showArrow
                                  {...this.getRateCodeSelectProps()}
                                  placeholder={Func.capitalizeFirstLetter(
                                    (
                                      t("placeHolderForm.select") +
                                      " " +
                                      t("item.tourTicket.rateCode")
                                    ).toLowerCase()
                                  )}
                                  value={tourTicket.rateCodeId}
                                  onChange={(id) => this.onSelectRateCodeID(id)}
                                  style={{ width: "100%" }}
                                  disabled={tourTicket.id}
                                >
                                  {(rateCodeAll || []).map((r) => (
                                    <AntOption key={r.id} value={r.id}>{`${
                                      r.code
                                    } | ${r.name} | ${Func.formatMoney(
                                      r.sellCost
                                    )}`}</AntOption>
                                  ))}
                                </AntSelect>
                              </div>
                            )}
                          {this.state.action === DETAIL_ACTIONS.CREATE &&
                            (this.state?.tour?.type ===
                              RATECODE.GROUP_TYPE.TOUR.id ||
                              this.state?.tour?.type ===
                                RATECODE.GROUP_TYPE.VOUCHER.id) && (
                              <div className={`col-md-5 p-0`}>
                                <AntSelect
                                  className="select-destination"
                                  showArrow
                                  {...this.getRateCodeSelectProps()}
                                  placeholder={Func.capitalizeFirstLetter(
                                    (
                                      t("placeHolderForm.select") +
                                      " " +
                                      t("item.tourTicket.rateCode")
                                    ).toLowerCase()
                                  )}
                                  value={tourTicket.rateCodeId}
                                  onChange={(id) => this.onSelectRateCodeID(id)}
                                  style={{ width: "100%" }}
                                  disabled={tourTicket.id}
                                >
                                  {(rateCodeAll || [])
                                    .filter((el) => el.lengOfStay > 0)
                                    .map((r) => {
                                      return (
                                        <AntOption key={r.id} value={r.id}>{`${
                                          r.code
                                        } | ${r.name} | ${Func.formatMoney(
                                          r.sellCost
                                        )}`}</AntOption>
                                      );
                                    })}
                                </AntSelect>
                              </div>
                            )}
                          {this.state.action === DETAIL_ACTIONS.UPDATE && (
                            <div className={`col-md-5 p-0`}>
                              <AntSelect
                                className="select-destination"
                                showArrow
                                {...this.getRateCodeSelectProps()}
                                placeholder={Func.capitalizeFirstLetter(
                                  (
                                    t("placeHolderForm.select") +
                                    " " +
                                    t("item.tourTicket.rateCode")
                                  ).toLowerCase()
                                )}
                                value={tourTicket.rateCodeId}
                                onChange={(id) => this.onSelectRateCodeID(id)}
                                style={{ width: "100%" }}
                                disabled={tourTicket.id}
                              >
                                {(rateCodeAll || []).map((r) => (
                                  <AntOption key={r.id} value={r.id}>{`${
                                    r.code
                                  } | ${r.name} | ${Func.formatMoney(
                                    r.sellCost
                                  )}`}</AntOption>
                                ))}
                              </AntSelect>
                            </div>
                          )}
                          <Input
                            placeholder={t(`item.tourTicket.rateCodePrice`)}
                            type={`currency`}
                            className={`form-control ml-1`}
                            disabled
                            value={tourTicket.salePrice}
                            autoComplete="off"
                          />
                          <Input
                            placeholder={t(`item.tourTicket.salePercent`)}
                            type={`currency`}
                            className={`form-control ml-1`}
                            name={`originalPrice`}
                            onChange={(e) =>
                              this.onChange(
                                Number(e.target.value),
                                "originalPrice"
                              )
                            }
                            value={tourTicket.originalPrice}
                            autoComplete="off"
                            disabled={tourTicket.id}
                          />

                          <Input
                            placeholder={t(`item.tourTicket.originalPrice`)}
                            type={`currency`}
                            className={`form-control ml-1`}
                            disabled
                            value={Func.formatMoney(
                              tourTicket.salePrice /
                                (1 - tourTicket.originalPrice * 0.01)
                            )}
                            autoComplete="off"
                          />
                        </Wrapper>
                      </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-2`}>
                      <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.tourTicket.multiple`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <Input
                          placeholder={t(`item.tourTicket.multiple`)}
                          className={`form-control ml-1 mr-1`}
                          name={`multiple`}
                          onChange={(e) =>
                            e.target.value.length < 4 &&
                            this.onChange(Number(e.target.value), "multiple")
                          }
                          value={tourTicket.multiple}
                          autoComplete="off"
                          disabled={tourTicket.id}
                        />
                      </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-6`} style={{ bottom: 7 }}>
                      <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.ratecode.surchargeCategory`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <AntSelect
                          className="select-types"
                          showArrow
                          mode="multiple"
                          name="surchargeCategoryIds"
                          placeholder={Func.capitalizeFirstLetter(
                            (
                              t("placeHolderForm.select") +
                              " " +
                              t("item.ratecode.surchargeCategory")
                            ).toLowerCase()
                          )}
                          value={tourTicket.surchargeCategoryIds}
                          onChange={(values) =>
                            this.onChange(values, "surchargeCategoryIds")
                          }
                          filterOption={this.selectFilterSearch}
                          style={{ width: "100%" }}
                          disabled={tourTicket.id}
                        >
                          {(tourSurchargeCategories || []).map(
                            (surchargeCategory) => (
                              <AntOption
                                key={surchargeCategory.id}
                                value={surchargeCategory.id}
                              >
                                {surchargeCategory.name}
                              </AntOption>
                            )
                          )}
                        </AntSelect>
                      </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-2`} style={{ bottom: 7 }}>
                      <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.tourTicket.minQuantity`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <Input
                          placeholder={t(`item.tourTicket.minQuantity`)}
                          type={`currency`}
                          className={`form-control ml-1`}
                          value={tourTicket.minQuantity}
                          autoComplete="off"
                          onChange={(e) =>
                            this.onChange(Number(e.target.value), "minQuantity")
                          }
                          disabled={tourTicket.id}
                        />
                      </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-2`} style={{ bottom: 7 }}>
                      <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.tourTicket.maxQuantity`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <Input
                          placeholder={t(`item.tourTicket.maxQuantity`)}
                          type={`currency`}
                          className={`form-control ml-1`}
                          value={tourTicket.maxQuantity}
                          autoComplete="off"
                          onChange={(e) =>
                            this.onChange(Number(e.target.value), "maxQuantity")
                          }
                          disabled={tourTicket.id}
                        />
                      </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-1`} style={{ bottom: 7 }}>
                      <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.tourTicket.isEnableListing`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <div>
                          <Switch
                            defaultChecked
                            checked={tourTicket.isEnableListing}
                            onChange={(checked) =>
                              this.onChange(checked, "isEnableListing")
                            }
                          />
                        </div>
                      </HMS.FormWrapperInputComponent>
                    </div>
                    {/* Inventory */}
                    <div className={`col-md-12`}>
                      {isTourType && this.renderConfigSamePrice()}
                    </div>
                  </Fragment>
                )}
                {objectTypeSelect === OBJECT_TYPE.SELECT.SPECIFIC.id && (
                  <Fragment>
                    <div className={`col-md-3`}>
                      <HMS.FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        dataValidation={tourTicket.objectType?.id}
                        validation={validation.objectTypeId}
                        labelTitle={t(`item.tourTicket.objectType`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <AntSelect
                          className="select-destination"
                          showArrow
                          showSearch
                          placeholder={Func.capitalizeFirstLetter(
                            (
                              t("placeHolderForm.select") +
                              " " +
                              t("item.tourTicket.objectType")
                            ).toLowerCase()
                          )}
                          value={tourTicket.objectType?.objectTypeId}
                          onChange={this.onChangeObjectType}
                          style={{ width: "100%" }}
                          filterOption={this.selectFilterSearch}
                        >
                          {(tourState?.detail?.tour?.type === 7
                            ? allObjectTypeForVinWonder
                            : allObjectType
                          ).map((d) => (
                            <AntOption key={d.id} value={d.id}>
                              {d.name} - {d.code}
                            </AntOption>
                          ))}
                        </AntSelect>
                      </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-1`}></div>
                    <div className={`col-md-5`}>
                      <div className="d-flex align-items-center justify-content-between">
                        <HMS.FormWrapperInputComponent
                          isRequired={true}
                          isValidation={true}
                          dataValidation={tourTicket.salePrice}
                          validation={validation.salePrice}
                          labelTitle={t(`item.tourTicket.salePrice`)}
                          visible={action !== DETAIL_ACTIONS.TRANSLATE}
                          className="w-100"
                        >
                          <AntSelect
                            className="select-destination"
                            showArrow
                            {...this.getRateCodeSelectProps()}
                            placeholder={Func.capitalizeFirstLetter(
                              (
                                t("placeHolderForm.select") +
                                " " +
                                t("item.tourTicket.rateCode")
                              ).toLowerCase()
                            )}
                            value={this.getSelectedRateCode(isCombo)}
                            onChange={(id) =>
                              isCombo
                                ? this.setState({ selectedRateCodeId: id })
                                : this.onChange(id, "rateCodeId")
                            }
                            style={{ width: "100%" }}
                          >
                            {/* { (rateCodeAll || []).filter(el => el.lengOfStay).map(r => {
                                                            return(
                                                                <AntOption
                                                                    disabled={ !!find(tourTicket.objectTypePrice, item => item.objectTypeId === tourTicket.objectType?.objectTypeId && item.rateCodeId === r.id) }
                                                                    key={ r.id }
                                                                    value={ r.id }>{`${r.code} | ${r.name} | ${Func.formatMoney(r.sellCost)}`}</AntOption>
                                                            ) }
                                                            )
                                                        } */}
                            {(detail?.tour?.type ===
                              RATECODE.GROUP_TYPE.TOUR.id ||
                              detail?.tour?.type ===
                                RATECODE.GROUP_TYPE.VOUCHER.id) &&
                              (rateCodeAll || [])
                                .filter((el) => el.lengOfStay > 0)
                                .map((r) => {
                                  return (
                                    <AntOption
                                      disabled={
                                        !!find(
                                          tourTicket.objectTypePrice,
                                          (item) =>
                                            item.objectTypeId ===
                                              tourTicket.objectType
                                                ?.objectTypeId &&
                                            item.rateCodeId === r.id
                                        )
                                      }
                                      key={r.id}
                                      value={r.id}
                                    >{`${r.code} | ${
                                      r.name
                                    } | ${Func.formatMoney(
                                      r.sellCost
                                    )}`}</AntOption>
                                  );
                                })}
                            {detail?.tour?.type ===
                              RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id &&
                              (rateCodeAll || []).map((r) => {
                                return (
                                  <AntOption
                                    disabled={
                                      !isCombo &&
                                      !!find(
                                        tourTicket.objectTypePrice,
                                        (item) =>
                                          item.objectTypeId ===
                                            tourTicket.objectType
                                              ?.objectTypeId &&
                                          item.rateCodeId === r.id
                                      )
                                    }
                                    key={r.id}
                                    value={r.id}
                                  >{`${r.code} | ${r.name} | ${Func.formatMoney(
                                    r.sellCost
                                  )}`}</AntOption>
                                );
                              })}
                          </AntSelect>
                        </HMS.FormWrapperInputComponent>

                        {isCombo && (
                          <Button
                            type="primary"
                            className="ml-2 mt-3"
                            onClick={this.onAddRateCodesIntoCombo}
                          >
                            {t(`action.add`)}
                          </Button>
                        )}
                      </div>

                      <ComboRateCode
                        t={t}
                        rateCodes={comboRateCodes || []}
                        allObjectType={
                          allObjectTypeForVinWonderWithoutCombo || []
                        }
                        setObjectForCombo={(comboItemList) =>
                          this.setState({ comboRateCodes: comboItemList })
                        }
                        isCombo={isCombo}
                        allObjectTypeForVinWonderWithRateCodeType={
                          objectTypeState.allObjectType
                        }
                      />
                    </div>
                    <div className={`col-md-6`}>
                      <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.ratecode.surchargeCategory`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <AntSelect
                          className="select-types"
                          showArrow
                          mode="multiple"
                          name="surchargeCategoryIds"
                          placeholder={Func.capitalizeFirstLetter(
                            (
                              t("placeHolderForm.select") +
                              " " +
                              t("item.ratecode.surchargeCategory")
                            ).toLowerCase()
                          )}
                          value={tourTicket.surchargeCategoryIds}
                          onChange={(values) =>
                            this.onChange(values, "surchargeCategoryIds")
                          }
                          filterOption={this.selectFilterSearch}
                          style={{ width: "100%" }}
                        >
                          {(tourSurchargeCategories || []).map(
                            (surchargeCategory) => (
                              <AntOption
                                key={surchargeCategory.id}
                                value={surchargeCategory.id}
                              >
                                {surchargeCategory.name}
                              </AntOption>
                            )
                          )}
                        </AntSelect>
                      </HMS.FormWrapperInputComponent>
                    </div>

                    <div className={`col-md-12`}>
                      <Wrapper className="d-flex align-items-center mt-2">
                        {/* <Input placeholder={ t(`item.tourTicket.originalPrice`) } type={ `currency` }
                                                    className={ `form-control mr-1` }
                                                    name={ `originalPrice` } onChange={ (e) => this.onChange(Number(e.target.value), 'originalPrice') }
                                                    value={ tourTicket.originalPrice } autoComplete="off"/> */}
                        <Input
                          placeholder={t(`item.tourTicket.rateCodePrice`)}
                          type={`currency`}
                          className={`form-control ml-1`}
                          disabled
                          value={tourTicket.salePrice}
                          autoComplete="off"
                        />
                        <Input
                          placeholder={t(`item.tourTicket.salePercent`)}
                          type={`currency`}
                          className={`form-control ml-1`}
                          name={`originalPrice`}
                          onChange={(e) =>
                            this.onChange(
                              Number(e.target.value),
                              "originalPrice"
                            )
                          }
                          value={tourTicket.originalPrice}
                          autoComplete="off"
                        />
                        <Input
                          placeholder={t(`item.tourTicket.originalPrice`)}
                          type={`currency`}
                          className={`form-control ml-1`}
                          disabled
                          value={Func.formatMoney(
                            tourTicket.salePrice /
                              (1 - tourTicket.originalPrice * 0.01)
                          )}
                          autoComplete="off"
                        />
                        <div
                          className={`col-md-2 p-0 mr-1`}
                          style={{ bottom: 7 }}
                        >
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.tourTicket.minQuantity`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                          >
                            <Input
                              placeholder={t(`item.tourTicket.minQuantity`)}
                              type={`currency`}
                              className={`form-control ml-1`}
                              value={tourTicket.minQuantity}
                              autoComplete="off"
                              onChange={(e) =>
                                this.onChange(
                                  Number(e.target.value),
                                  "minQuantity"
                                )
                              }
                            />
                          </HMS.FormWrapperInputComponent>
                        </div>
                        <div
                          className={`col-md-2 p-0 mr-1`}
                          style={{ bottom: 7 }}
                        >
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.tourTicket.maxQuantity`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                          >
                            <Input
                              placeholder={t(`item.tourTicket.maxQuantity`)}
                              type={`currency`}
                              className={`form-control ml-1`}
                              value={tourTicket.maxQuantity}
                              autoComplete="off"
                              onChange={(e) =>
                                this.onChange(
                                  Number(e.target.value),
                                  "maxQuantity"
                                )
                              }
                            />
                          </HMS.FormWrapperInputComponent>
                        </div>
                        <div className={`col-md-2 p-0`} style={{ bottom: 7 }}>
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.tourTicket.multiple`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                          >
                            <Wrapper className="d-flex align-items-center">
                              <Input
                                placeholder={t(`item.tourTicket.multiple`)}
                                className={`form-control ml-1 mr-1`}
                                name={`multiple`}
                                onChange={(e) =>
                                  e.target.value.length < 4 &&
                                  this.onChange(
                                    Number(e.target.value),
                                    "multiple"
                                  )
                                }
                                value={tourTicket.multiple}
                                autoComplete="off"
                                disabled={isCombo}
                              />
                              <Button
                                type="primary"
                                className="ml-1"
                                disabled={isDisabledAddObjectType}
                                onClick={() => this.onAddObjectType(isCombo)}
                              >
                                {t(`action.add`)}
                              </Button>
                            </Wrapper>
                          </HMS.FormWrapperInputComponent>
                        </div>
                      </Wrapper>
                    </div>

                    {isTourType && this.renderConfig()}
                    {!!validation.objectTypeValidate?.messageError && (
                      <Wrapper className="text-red">
                        * {validation.objectTypeValidate?.messageError || ""}
                      </Wrapper>
                    )}
                    <div
                      className={classNames(`col-md-12`, {
                        "border-red": !!validation.objectTypeValidate,
                      })}
                    >
                      <HMS.ListComponent
                        tableKey="table-tour-ticket-object-type"
                        rowKey={(record) =>
                          `${record.objectTypeId}-${record.rateCodeId}`
                        }
                        dataSource={Func.getDataSource(
                          tourTicket.objectTypePrice,
                          modelObjectType
                        )}
                        columns={Func.columnsTable({
                          titleTable: titleTable,
                          component: { ...componentTable },
                          itemName: "tourTicket",
                        })}
                        rowClassName={(record, index) => {
                          if (
                            tourTicketItemSelectedId &&
                            (record.id === tourTicketItemSelectedId ||
                              record.localId === tourTicketItemSelectedId)
                          )
                            return "table-row-light";
                          return "";
                        }}
                      />
                    </div>
                  </Fragment>
                )}
                {action === DETAIL_ACTIONS.UPDATE && (
                  <AutoTranslate
                    className="wrapper-full tour-ticket"
                    languageCode={tourTicket?.languageCode || 'vi-VN'}
                    onChange={this.onChangeField}
                    targetLanguage={tourTicket?.targetLanguage}
                  />
                )}
              </HMS.FormWrapperItem>
            </HMS.FormActionComponent>
          </HMS.PageListComponent>
        </HMS.LoadingComponent>
      </Fragment>
    );
  }

  validatePrice = () => {
    const { tourTicket } = this.state;
    let isError = false;
    tourTicket.objectTypePrice.forEach((item) => {
      if (item.salePrice > item.originalPrice) {
        isError = true;
      }
    });

    return isError;
  };

  validateMinMaxQuantity = (data) => {
    let isError = false;
    if (this.state.objectTypeSelect === OBJECT_TYPE.SELECT.SPECIFIC.id) {
      if (data.objectTypePrice && data.objectTypePrice.length > 0) {
        data.objectTypePrice.forEach((item) => {
          if (item.maxQuantity && item.minQuantity > item.maxQuantity) {
            isError = true;
          }
        });
      }
    } else {
      if (data.maxQuantity && data.minQuantity > data.maxQuantity) {
        isError = true;
      }
    }

    return isError;
  };

  validateMinQuantity = (data) => {
    let isError = false;
    if (this.state.objectTypeSelect === OBJECT_TYPE.SELECT.SPECIFIC.id) {
      if (data.objectTypePrice && data.objectTypePrice.length > 0) {
        data.objectTypePrice.forEach((item) => {
          if (
            item.minQuantity &&
            (item.minQuantity < item.multiple ||
              item.minQuantity % item.multiple > 0)
          ) {
            isError = true;
          }
        });
      }
    } else {
      if (
        data.minQuantity &&
        (data.minQuantity < data.multiple ||
          data.minQuantity % data.multiple > 0)
      ) {
        isError = true;
      }
    }

    return isError;
  };

  validateMaxQuantity = (data) => {
    let isError = false;
    if (this.state.objectTypeSelect === OBJECT_TYPE.SELECT.SPECIFIC.id) {
      if (data.objectTypePrice && data.objectTypePrice.length > 0) {
        data.objectTypePrice.forEach((item) => {
          if (item.maxQuantity % item.multiple > 0) {
            isError = true;
          }
        });
      }
    } else {
      if (data.maxQuantity % data.multiple > 0) {
        isError = true;
      }
    }

    return isError;
  };

  selectFilterSearch = (input, option) => {
    const optionText = Func.vietnameseStringToUnicode(
      option.props.children[0].toLowerCase()
    );
    const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
    return optionText.indexOf(inputText) >= 0;
  };
}

export default withTranslation()(TourTicketDetail);
